import React from 'react';
import { faSquare, faSquareCheck } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Loading from './loading';

export default class SelectProvide extends React.Component {
    constructor(props) {
        super(props);
    }

    handleSelectProvideChange = (provide_date, time_section) => {
        this.props.onSelectProvideChange(provide_date, time_section);
    }

    render() {
        const provide_list = [];
        if (Object.keys(this.props.provide_list).length > 0) {
            const keys = Object.keys(this.props.provide_list);
            for(const key of keys) {
                const [provide_date, time_section] = key.split('_');
                provide_list.push(
                    <div className={this.props.provide_date === provide_date && this.props.time_section === time_section ? 'check-select select-block-1' : 'no-check-select select-block-1'} onClick={() => this.handleSelectProvideChange(provide_date, time_section)}>
                        {
                            this.props.provide_date === provide_date && this.props.time_section === time_section &&
                            <div className="select-block-1-1"><FontAwesomeIcon icon={faSquareCheck} /></div>
                        }
                        {
                            (this.props.provide_date !== provide_date || this.props.time_section !== time_section) &&
                            <div className="select-block-1-1"><FontAwesomeIcon icon={faSquare} /></div>
                        }
                        <div className="select-block-1-2">{this.props.provide_list[key]}</div>
                    </div>
                );
            }
        }
        return (
            <div className={`select-provide-flex ${this.props.className ?? ''}`}>
                <h1 className="bb-1px-solid">日付／時間帯</h1>
                <div className="select-group">
                    {
                        provide_list.length == 0 && !this.props.is_not_provide &&
                        <Loading />
                    }
                    {
                        provide_list.length == 0 && this.props.is_not_provide &&
                        <p>
                            申し訳ありません。<br />
                            提供予定のメニューがないため、日付／時間帯を選択できません。
                        </p>
                    }
                    {
                        provide_list.length > 0 &&
                        provide_list
                    }
                </div>
            </div>
        );
    }
}